import { ContainerModule } from 'inversify';
import { PracticeSessionReducerPlugin } from './practice-session-reducer-plugin'
import { QuizSessionReducerPluginSymbol } from '@/app/quiz-session/api';

export const practiceSessionDomainModule = new ContainerModule((bind) => {
  bind(QuizSessionReducerPluginSymbol).to(PracticeSessionReducerPlugin).whenTargetNamed('practice')
});
